// Enhanced error logging and recovery for ActiveStorage Direct Uploads
export function setupActiveStorageErrorLogging() {
  // Override the default DirectUploadController error handler
  if (window.ActiveStorage && window.ActiveStorage.DirectUploadController) {
    const originalError = window.ActiveStorage.DirectUploadController.prototype.dispatchError
    
    window.ActiveStorage.DirectUploadController.prototype.dispatchError = function(error) {
      // Log detailed error information
      console.error("[ActiveStorage] Direct upload error:", {
        error: error,
        file: this.file ? {
          name: this.file.name,
          size: this.file.size,
          type: this.file.type
        } : null,
        url: this.url,
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent
      })
      
      // Send error to server for tracking (if needed)
      if (window.location.hostname !== 'localhost') {
        try {
          fetch('/api/log_upload_error', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
            },
            body: JSON.stringify({
              error: error.toString(),
              file_name: this.file?.name,
              file_size: this.file?.size,
              file_type: this.file?.type,
              timestamp: new Date().toISOString()
            })
          }).catch(() => {
            // Silently fail if logging fails
          })
        } catch (e) {
          // Ignore logging errors
        }
      }
      
      // Call the original error handler
      originalError.call(this, error)
    }
  }
  
  // Add global listener for unhandled direct upload errors
  document.addEventListener('direct-upload:error', (event) => {
    const { error, file } = event.detail
    
    // Check if this is a network error that might be recoverable
    if (error.toString().includes('NetworkError') || error.toString().includes('Failed to fetch')) {
      console.warn("[ActiveStorage] Network error detected, suggesting retry:", {
        fileName: file.name,
        error: error.toString()
      })
      
      // Find the file input and show a retry message
      const fileInput = event.target.querySelector('input[type="file"][data-direct-upload-url]')
      if (fileInput) {
        const retryMessage = document.createElement('div')
        retryMessage.className = 'mt-2 p-3 bg-yellow-100 border border-yellow-400 text-yellow-700 rounded'
        retryMessage.innerHTML = `
          <strong>Upload failed due to network error.</strong><br>
          Please check your internet connection and try selecting the file again.
        `
        fileInput.parentElement.appendChild(retryMessage)
        
        // Remove the message after 10 seconds
        setTimeout(() => retryMessage.remove(), 10000)
      }
    }
  })
  
  // Monitor for stuck uploads (no progress for 30 seconds)
  const uploadTimeouts = new Map()
  
  document.addEventListener('direct-upload:progress', (event) => {
    const { id } = event.detail
    
    // Clear any existing timeout
    if (uploadTimeouts.has(id)) {
      clearTimeout(uploadTimeouts.get(id))
    }
    
    // Set a new timeout
    const timeout = setTimeout(() => {
      console.error("[ActiveStorage] Upload appears to be stuck:", {
        uploadId: id,
        lastProgress: event.detail.progress
      })
      
      // Dispatch a custom event that the UI can listen to
      const stuckEvent = new CustomEvent('direct-upload:stuck', {
        detail: { id, lastProgress: event.detail.progress }
      })
      event.target.dispatchEvent(stuckEvent)
    }, 30000) // 30 seconds
    
    uploadTimeouts.set(id, timeout)
  })
  
  // Clear timeouts when uploads complete or error
  document.addEventListener('direct-upload:end', (event) => {
    const { id } = event.detail
    if (uploadTimeouts.has(id)) {
      clearTimeout(uploadTimeouts.get(id))
      uploadTimeouts.delete(id)
    }
  })
  
  document.addEventListener('direct-upload:error', (event) => {
    const { id } = event.detail
    if (uploadTimeouts.has(id)) {
      clearTimeout(uploadTimeouts.get(id))
      uploadTimeouts.delete(id)
    }
  })
  
  console.log("[ActiveStorage] Enhanced error logging and monitoring initialized")
}